module.exports = __webpack_public_path__ + "static/gavilanwork5-c5a3b2b9b9babd6e9b9fa70155b11fe0.jpg";